import { useEffect } from "react";

/**
 * Hook customizado para definir o título da página e Meta Tags de SEO
 * @param {string} title - Título da página (será concatenado com " - BotGate")
 * @param {string} description - Opcional: Descrição da página para SEO
 */
export const usePageTitle = (title, description) => {
  useEffect(() => {
    const previousTitle = document.title;
    const fullTitle = title ? `${title} - BotGate` : "BotGate";
    document.title = fullTitle;

    // Função auxiliar para atualizar meta tags
    const updateMeta = (nameOrProperty, content, isProperty = false) => {
      const selector = isProperty ? `meta[property="${nameOrProperty}"]` : `meta[name="${nameOrProperty}"]`;
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute("content", content);
      }
    };

    if (description) {
      updateMeta("description", description);
      updateMeta("og:description", description, true);
      updateMeta("twitter:description", description, true);
    }

    updateMeta("og:title", fullTitle, true);
    updateMeta("twitter:title", fullTitle, true);

    return () => {
      document.title = previousTitle;
    };
  }, [title, description]);
};

export default usePageTitle;
